import { makeStyles } from "@material-ui/core/styles";

export const useFilterButtonStyles = makeStyles(() => ({
  actions: {
    padding: "0 24px 15px",
  },
  apply: {
    color: "#ffffff",
  },
  button: {
    "font-size": "small",
    marginLeft: "15px",
  },
  gridButton: {
    float: "right",
    "margin-right": "45px",
    "margin-bottom": "-35px",
  },
  popover: {
    width: "400px",
  },
}));
